import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from '../../style/LayoutComponents';
import { cssClass, Style } from '../../style/StyleFunctions';

export namespace ComposeEmailDialogStyles {
  export const PREFIX = 'compose-email-dialog';
  export const DIALOG_WIDTH = 500;
  export const TEXT_AREA_HEIGHT = 200;

  export const MAXIMUM_BODY_LENGTH = 4000;
  export const MAXIMUM_SUBJECT_LENGTH = 78;

  export function TEST_ID(suffix: string) {
    return PREFIX + suffix;
  }

  export const LabelTextDiv = divWithStyle(TEST_ID('label-text'), {
    paddingTop: TabStyles.Spacing.DefaultSpace,
    paddingBottom: TabStyles.Spacing.DefaultSpace,
    fontSize: TabStyles.Typography.Sizing.Default,
    color: TabStyles.Typography.Color.Primary,
  });

  export const RecipientsDiv = divWithStyle(TEST_ID('recipients'), {
    paddingBottom: TabStyles.Spacing.MediumSpace,
  });

  export const subjectStyle: React.CSSProperties & Style = { // resolve conflicting types, but FIXME better than this someday
    width: '100%'
  };

  export const subjectContainer = cssClass('subjectContainerClass', {
    ...subjectStyle
  });

  export const messageAreaStyle: React.CSSProperties = {
    height: TEXT_AREA_HEIGHT,
    resize: 'none'
  };

  export const messageAreaClass = cssClass(TEST_ID('text-area'), {
    outline: 'none',
    boxSizing: 'border-box',
    width: '100%',
    overflow: 'auto',
    fontSize: TabStyles.Typography.Sizing.Default,
    marginBottom: TabStyles.Spacing.MediumSpace,
    paddingTop: TabStyles.Spacing.DefaultSpace,
    paddingBottom: TabStyles.Spacing.DefaultSpace
  });

  export const emailButtonStyle: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.LargeSpace,
  };

  export const buttonStyleSubmitting: React.CSSProperties = {
    verticalAlign: 'sub',
  };

  export const dialogBodyStyle: React.CSSProperties = {
    paddingTop: TabStyles.Spacing.MediumSpace,
    paddingBottom: TabStyles.Spacing.MediumSpace,
  };
}
